const Constants = {
  MENU_OPEN: 'MENU_OPEN',
};

export const reducerConstants = Constants;
